import {useCurrentUser} from "~/auth/hooks";
import {useEffect} from "react";
import {useSyncPushSubscription} from "~/notifications/hooks";


export type NotificationProviderProps = {
    children?: any
}


export const NotificationProvider = ({children}: NotificationProviderProps) => {
    const [user, loading] = useCurrentUser();
    const [syncPushSubscription] = useSyncPushSubscription();

    useEffect(() => {
        if (user) {
            syncPushSubscription();
        }
    }, [user, syncPushSubscription]);

    return children;
}